import Zone from "../../Models/Zone";

export const GET_ZONES = "Zone/getZones";
export const GET_ZONES_BY_CITY = "Zone/getZonesByCity";

export interface ZoneReducerType {
  zones: Zone[],
  zonesByCity: Zone[]
}
